import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { EvidenceBadge } from "@/components/common/EvidenceBadge";

export default function AdminContent() {
  const [caps, setCaps] = useState([]);
  const load = () => api.get("/admin/content/capabilities").then(({ data }) => setCaps(data.results));
  useEffect(() => { load(); }, []);

  const toggle = async (slug, published) => {
    try {
      await api.patch(`/admin/content/capabilities/${slug}`, null, { params: { published: !published } });
      toast.success(!published ? "Published" : "Unpublished");
      load();
    } catch {
      toast.error("Action failed");
    }
  };

  return (
    <div>
      <h1 className="font-display text-3xl font-bold text-navy">Content</h1>
      <p className="mt-1 text-sm text-[var(--mineral)]">Publish or unpublish catalogue capabilities. Draft content is never publicly accessible.</p>
      <div className="mt-6 overflow-hidden rounded-2xl border border-[var(--line)] bg-[var(--paper)]">
        <table className="w-full text-sm">
          <thead className="border-b border-[var(--line)] bg-[var(--ivory)] text-left">
            <tr>
              <th className="p-4 font-medium text-navy">Title</th>
              <th className="p-4 font-medium text-navy">Evidence</th>
              <th className="p-4 font-medium text-navy">State</th>
              <th className="p-4"></th>
            </tr>
          </thead>
          <tbody>
            {caps.map((c) => (
              <tr key={c.slug} className="border-b border-[var(--line)] last:border-0" data-testid={`content-row-${c.slug}`}>
                <td className="p-4 font-medium text-navy">{c.title}</td>
                <td className="p-4"><EvidenceBadge status={c.evidence_status} /></td>
                <td className="p-4">
                  <span className={`rounded-full px-2.5 py-1 font-mono text-xs ${c.published ? "bg-[var(--success)]/15 text-[var(--success)]" : "bg-[var(--mineral)]/15 text-[var(--mineral)]"}`}>
                    {c.published ? "Published" : "Draft"}
                  </span>
                </td>
                <td className="p-4 text-right">
                  <button onClick={() => toggle(c.slug, c.published)} data-testid={`toggle-publish-${c.slug}`} className="rounded-full border border-[var(--line)] px-3 py-1.5 text-xs font-semibold text-navy hover:border-[var(--cobalt)]">
                    {c.published ? "Unpublish" : "Publish"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
